function openNativeDatePicker(input) {
    if (!input) return;

    input.focus();

    if (typeof input.showPicker === 'function') {
        try {
            input.showPicker();
            return;
        } catch (_error) {}
    }

    input.click();
}

document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-date-picker-trigger]');
    if (!trigger) return;

    event.preventDefault();
    const wrapper = trigger.closest('.date-input-wrapper');
    const target = wrapper && wrapper.querySelector('[data-date-picker-input]');
    openNativeDatePicker(target);
});

document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest('[data-date-picker-trigger]');
    if (!trigger || (event.key !== 'Enter' && event.key !== ' ')) return;

    event.preventDefault();
    const wrapper = trigger.closest('.date-input-wrapper');
    const target = wrapper && wrapper.querySelector('[data-date-picker-input]');
    openNativeDatePicker(target);
});
